import { useSelector } from 'react-redux'
import { AppState } from '..'
import { User } from '@supabase/supabase-js'

export function useUserAuthAccessToken(): string | undefined {
  const userAuthAccessToken = useSelector(
    (state: AppState) => state.userAuth.session?.access_token
  )

  return userAuthAccessToken
}

export function useUserAuthData(): User | undefined {
  const userData = useSelector(
    (state: AppState) => state.userAuth.session?.user
  )

  return userData
}
